var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex-level p-3 bt-1" }, [
      _c("div", { staticClass: "wp-4" }, [
        _c("p", { staticClass: "grey mb-1 mt-0" }, [
          _vm._v(" " + _vm._s(_vm.$l10n.__("Compte")) + " ")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "my-0" }, [_vm._v(_vm._s(_vm.email))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wp-3" }, [
        _c("p", { staticClass: "grey mb-1 mt-0" }, [
          _vm._v(" " + _vm._s(_vm.$l10n.__("Statut")) + " ")
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "chip",
          class: "chip-" + _vm.syncStatus.type
        }),
        _vm._v(_vm._s(_vm.syncStatus.message) + "\n        ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wp-2" },
        [
          _c(
            "el-dropdown",
            { attrs: { placement: "bottom-end" } },
            [
              _c("span", { staticClass: "link" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Options")))
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", [
                    _c(
                      "a",
                      {
                        staticClass: "btn-loading",
                        attrs: { href: "?_f=prefsNylas&action=cleanCache" }
                      },
                      [_vm._v(_vm._s(_vm.$l10n.__("Mettre à jour le cache")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-dropdown-item", [
                    _c(
                      "a",
                      {
                        staticClass: "btn-loading",
                        attrs: { href: "?_f=prefsNylas&action=checkStatus" }
                      },
                      [_vm._v(_vm._s(_vm.$l10n.__("Actualiser le statut")))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex-item-right" }, [
        _vm.isAdmin || !_vm.isEmailsSentFromCorp
          ? _c(
              "a",
              {
                staticClass: "btn btn-danger fright",
                on: {
                  click: function($event) {
                    return _vm.logout()
                  }
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$l10n.__("Déconnexion")) +
                    "\n            "
                )
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }